import { IconRegularChevronRight } from '@notino/react-styleguide'
import React from 'react'
import { useIntl } from 'react-intl'
import useMessages from '../../../../hooks/useMessages'

// assets
import FileIcon from '../../../../assets/icons/FileIcon'

// types
import { SalonDetail } from '../../../../types/types'

// utils
import { isFilePDF } from '../../../../utils/helper'

// styles
import * as SC from './SalonPricelistsStyles'

type Pricelists = SalonDetail['pricelists']

// helpers
const sortPricelists = (pricelists: Pricelists) => {
	const imagePricelists: Pricelists = []
	const pdfPricelists: Pricelists = []
	pricelists.forEach((pricelist) => {
		if (isFilePDF(pricelist.original)) {
			pdfPricelists.push(pricelist)
		} else {
			imagePricelists.push(pricelist)
		}
	})
	const pricelistsSorted = [...imagePricelists, ...pdfPricelists]
	return pricelistsSorted
}

type Props = {
	pricelists: SalonDetail['pricelists']
	hideHeading?: boolean
}

const SalonPricelists = (props: Props) => {
	const { messages } = useMessages()
	const { formatMessage } = useIntl()
	const { pricelists, hideHeading } = props

	const pricelistsSorted = sortPricelists(pricelists || [])

	const getOpenPricelistAriaLabel = (fileName: string) =>
		formatMessage({ id: 'Open price list {fileName}', defaultMessage: 'Open price list {fileName}' }, { fileName })

	const content = (
		<>
			{!hideHeading && <SC.SalonPriceListsTitle>{messages['Price list']}</SC.SalonPriceListsTitle>}
			<SC.SalonPriceListsFiles>
				{pricelistsSorted.map((priceList) =>
					isFilePDF(priceList.original) ? (
						<SC.SalonPricePdfPlaceholder
							type='button'
							key={priceList.id}
							aria-label={getOpenPricelistAriaLabel(priceList.fileName)}
							onClick={() => window.open(priceList.original)}
						>
							<SC.SalonPricePdfTitle>
								<SC.FileIcon>
									<FileIcon />
								</SC.FileIcon>
								<SC.FileName>
									<span>{priceList.fileName}</span>
									<SC.ChevronIcon>
										<IconRegularChevronRight color={'icon.secondary'} />
									</SC.ChevronIcon>
								</SC.FileName>
								<SC.OpenPdfFile>{messages['To open']}</SC.OpenPdfFile>
							</SC.SalonPricePdfTitle>
						</SC.SalonPricePdfPlaceholder>
					) : (
						<SC.SalonPriceListsImage
							type='button'
							key={priceList.id}
							aria-label={getOpenPricelistAriaLabel(priceList.fileName)}
							onClick={() => window.open(priceList.original)}
						>
							<img loading='lazy' alt='' key={priceList.id} src={priceList.original} />
						</SC.SalonPriceListsImage>
					)
				)}
			</SC.SalonPriceListsFiles>
		</>
	)

	if (hideHeading) {
		return content
	}

	return <section>{content}</section>
}
export default SalonPricelists
